import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { AppState } from '../../../../app.reducers';
import { Store } from '@ngrx/store';
import { ClearBackTo } from '../../../component/component-store';

@Component({
  selector: 'sp-admin-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
  standalone: false
})
export class AdminLeftMenuComponent implements OnInit, OnDestroy {

  @Input() userIsSmartPropertyAdmin = false;
  @Output() navigationToggled = new EventEmitter<boolean>();

  isCollapsed = false;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    // Apply initial state
    this.updateBodyClass();
  }

  ngOnDestroy() {
    // Clean up body class when component is destroyed
    document.body.classList.remove('nav-collapsed');
  }

  clearBackTo() {
    this.store.dispatch(new ClearBackTo());
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.updateBodyClass();
    this.updateMainComponentClass();
    this.navigationToggled.emit(this.isCollapsed);
  }

  private updateMainComponentClass() {
    const div = document.querySelector('.sp-admin-main .sp-table-row .main');
    if (div) {
      if (this.isCollapsed) {
        div.classList.add('menu-collapsed');
        div.classList.remove('menu-noncollapsed');
      } else {
        div.classList.add('menu-noncollapsed');
        div.classList.remove('menu-collapsed');
      }
    }
  }

  private updateBodyClass() {
    if (this.isCollapsed) {
      document.body.classList.add('nav-collapsed');
    } else {
      document.body.classList.remove('nav-collapsed');
    }
  }
}
